module.exports = __webpack_public_path__ + "img/featuredartist (4).9d00043f.jpg";